/**
 * Dynamic API and Backend Base URL Resolver
 * Ensures reliable connectivity across:
 * 1. Laptop local development (localhost)
 * 2. Mobile devices testing on the same Wi-Fi / Local Network (LAN IP: 192.168.x.x, 10.x.x.x)
 * 3. Deployed production domain (soloway.lk / api.soloway.lk)
 */

export const getApiBaseUrl = () => {
  if (typeof window !== "undefined" && window.location) {
    const { hostname, protocol } = window.location;

    // Production domain detection
    if (hostname.includes("soloway.lk")) {
      return "https://api.soloway.lk/api";
    }

    // Localhost development
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return "http://localhost:5000/api";
    }

    // Mobile testing on local network (e.g. 192.168.1.x:3300 or 10.x.x.x)
    return `${protocol}//${hostname}:5000/api`;
  }

  const envUrl = process.env.REACT_APP_API_URL;
  return (envUrl || "http://localhost:5000/api").replace(/\/+$/, "");
};

export const getBackendBaseUrl = () => {
  const apiBase = getApiBaseUrl();
  return apiBase.replace(/\/api\/?$/, "");
};

export const API_URL = getApiBaseUrl();
export const BACKEND_URL = getBackendBaseUrl();

const apiConfig = {
  getApiBaseUrl,
  getBackendBaseUrl,
  API_URL,
  BACKEND_URL,
};

export default apiConfig;
